import {
  CustomisedContactDetailsNS,
  CustomisedContactDetailsSchema,
} from "@smart/bridge-types-basic";
import { buildTableDef } from "@smart/itops-constructs-basic";
import { wrapSchema } from "@smart/itops-utils-basic";

const customisedContactDetailsGuard = wrapSchema(
  CustomisedContactDetailsSchema,
);

export const CustomisedContactDetailsDef = buildTableDef(
  {
    namespace: CustomisedContactDetailsNS,
    guard: customisedContactDetailsGuard,
    keyFields: ["uri"],
    keySchema: { uri: "string" },
    ttlField: "deletedAtSec",
  } as const,
  {
    byTeam: {
      indexName: "byTeam",
      keyFields: ["teamUri"],
      keySchema: { teamUri: "string" },
    },
  } as const,
);
